import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Particles from 'vue-particles';
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Element.Dialog.props.modalAppendToBody.default=false
Element.Drawer.props.modalAppendToBody.default=false
import '@/theme/index.scss';
import { i18n } from '@/i18n/index.js';
import { globalComponentSize } from '@/utils/componentSize.js';
// 分页组件
import Pagination from "./components/Pagination";
import MyTable from "./components/MyTable";

Vue.use(Particles);
Vue.use(Element, { i18n: (key, value) => i18n.t(key, value), size: globalComponentSize });

Vue.config.productionTip = false;
Vue.prototype.bus = new Vue();

// 全局组件挂载
Vue.component('Pagination', Pagination)
Vue.component('MyTable', MyTable)

new Vue({
	router,
	store,
	i18n,
	render: (h) => h(App),
}).$mount('#app');
